import { useEffect, useState } from "react";

import { apiClient } from "../api/client.js";
import { useAuth } from "../auth/AuthContext.js";

export interface FleetOption {
  id: string;
  name: string;
}

export interface FleetOptionsResult {
  options: FleetOption[];
  loaded: boolean;
  error: string | null;
}

/** Fleets the caller can filter by: all fleets for platform admins, memberships otherwise. */
export function useFleetOptions(): FleetOptionsResult {
  const { user } = useAuth();
  const [options, setOptions] = useState<FleetOption[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!user) {
      return;
    }
    if (!user.is_platform_admin) {
      setOptions(user.fleets.map((f) => ({ id: f.id, name: f.name })));
      setLoaded(true);
      return;
    }
    apiClient["/api/v1/admin/fleets"]
      ["get"]({ parameters: {}, body: null })
      .then((res) => {
        if (res.code === 200) {
          setOptions(res.body.map((f) => ({ id: f.id, name: f.name })));
        }
      })
      .catch(() => {
        setOptions([]);
        setError("Failed to load fleets");
      })
      .finally(() => setLoaded(true));
  }, [user]);

  return { options, loaded, error };
}
